module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "doc-active.c2c3ce7b.png";